
<template>
  <div class="about">
    <div class="about-bg">
      <div class="about-bg-img">
        <img src="@/assets/about/banner.png" alt="">
      </div>
      <div class="about-bg-breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">{{ $t('about.breadcrumb.title') }}</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('about.breadcrumb.activeTitle') }}</li>
          </ol>
        </nav>
      </div>
      <div class="about-bg-position">
        <div :class="positionActive == index?'about-bg-position-item about-bg-position-item-active':'about-bg-position-item'" v-for="(item, index) in navList" :key="index" @click="positionClick(index,$event)">
          <a :href="item.id">{{ item.name }}</a>
        </div>
      </div>
      <div class="pc-fixed-icon" @click="openInquiryForm">
        <img src="@/assets/home/xinxi.png" alt="">
      </div>
    </div>
    <div class="about-cont">
      <div class="about-brand" id="about-brand">
        <div class="about-brand-item" v-for="(item, index) in aboutList[0]?.value">
          <div class="about-brand-item-img">
            <img :src="item.icon" alt="">
          </div>
          <div class="about-brand-item-title">
            {{ item.title }}
          </div>
          <div class="about-brand-item-line"></div>
          <div class="about-brand-item-text">
            {{ item.content }}
          </div>
        </div>
      </div>

      <div class="about-about">
        <div class="about-about-div">
          <div class="area-title-pc">
            <p>{{ aboutList[1]?.value[0]?.title }}</p>
            <p class="area-titleBottom-pc">{{ aboutList[1]?.value[0]?.subheading }}</p>
          </div>
          <div class="about-about-cont">
            <div class="about-about-cont-item">
              <img :src="aboutList[1]?.value[0]?.img" alt="KOMO">
              <span class="about-about-cont-item-span">{{ aboutList[1]?.value[0]?.subheading }}</span>
            </div>
            <div class="about-about-cont-item-pick">
              <div class="about-about-cont-item-pick-item">
                <div class="about-about-cont-item-pick-item-title">
                  <p class="about-about-cont-item-pick-item-title-p1">{{ aboutList[1]?.value[0]?.content_title }}</p>
                  <!-- <p class="about-about-cont-item-pick-item-title-p2">{{ aboutList[1]?.value[0]?.content_subheading }}</p> -->
                </div>
                <div class="about-about-cont-item-pick-item-cont">
                  {{ aboutList[1]?.value[0]?.conttent_content }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="about-service" id="about-service">
        <div class="area-title-pc">
          <p>{{ aboutList[2]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ aboutList[2]?.value[0]?.subheading }}</p>
        </div>
        <div class="about-service-cont">
          <div class="about-service-padding">
            <swiper :options="swiperOptionsService">
              <swiper-slide class="swiper-slide" v-for="item in aboutList[2]?.value[0]?.content" :key="item.id">
                <img :src="item.img" alt="">
                <div class="about-service-cont-item-title">
                  {{ item.title }}
                </div>
              </swiper-slide>
            </swiper>
            <!-- <div class="indicators">
              <div 
                :class="['item', ServiceIndex === index ? 'active' : '']"
                v-for="(_, index) in aboutList[2]?.value[0]?.content.length"
                :key="index"
              ></div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="about-team" id="about-team">
        <div class="area-title-pc">
          <p>{{ aboutList[3]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ aboutList[3]?.value[0]?.subheading }}</p>
        </div>
        <div class="about-team-cont">
          <div class="about-team-cont-item" v-for="(item,index) in aboutList[3]?.value[0]?.content">
            <div class="about-team-cont-item-img">
              <img :src="item.avatar" alt="">
            </div>
            <div class="about-team-cont-box">
              <div class="about-team-cont-box-name">
                {{ item.name }}
              </div>
              <div class="about-team-cont-box-title">
                {{ item.introduction }}
              </div>
              <div class="about-team-cont-box-titleBottom" v-html="item.content"></div>
              <!-- <div class="about-team-cont-box-text">
                {{ $t('about.teamMessageCount.veroniceIntroductionContent2') }}
              </div>
              <div class="about-team-cont-box-texttwo">
                {{ $t('about.teamMessageCount.veroniceIntroductionContent3') }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { getBannerListing,getDataList } from '@/api/komo'
let vm = null
import { bus } from '@/utils/bus';
export default {
  name: 'about',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      bannerList: [], //
      aboutList: [],
      
      activeTab: 'brandPositioning',
      swiperOptions: {
        autoplay: true,
        loop: true
      },
      navList: [
        {
          name: this.$t('about.tabs.brand'),
          id: '#about-brand'
        },
        {
          name: this.$t('about.tabs.service'),
          id: '#about-service'
        },
        {
          name: this.$t('about.tabs.team'),
          id: '#about-team'
        }
      ],
      positionActive: 0,
      // Service Idea ==========================================
      ServiceIndex: 0, // 当前轮播索引
      serviceSlides: [
        {
          id: 1,
          imgUrl: require('@/assets/about/service-1.png'),
        },
        {
          id: 2,
          imgUrl: require('@/assets/about/service-2.png'),
        },
        {
          id: 3,
          imgUrl: require('@/assets/about/service-3.png'),
        },
      ],
      // 设置 swiper 的选项，包括 slidesPerView 来一次显示多个 slides
      swiperOptionsService: {
        allowSlideNext: false,  // 禁止向右滑动
        allowSlidePrev: false,  // 禁止向左滑动
        allowTouchMove: false,  // 禁止触摸滑动
        noSwiping: true,       // 完全禁用滑动
        // pagination: {
        //   el: '.swiper-pagination', // 分页器的选择器，与上面的类名相对应
        //   clickable: false, // 允许点击分页器切换幻灯片
        //   // bulletActiveClass: 'home-swiper-one-active' // 自定义激活的分页器类名
        // },
        // on: {
        //   // 滑动改变时触发
        //   slideChange: function() {
        //     vm.ServiceIndex = this.realIndex
        //   }
        // },
        // autoplay: {
        //   delay: 5000, // 自动切换时间间隔
        //   disableOnInteraction: true // 用户操作后是否停止自动切换，默认为true
        // },
        // loop: true, // 无限循环
        // loopAdditionalSlides: 1, // 循环时额外复制的slide数量
        // slideToClickedSlide: true, // 点击slide直接切换
        slidesPerView: 4, // 一次显示3个 slides
        spaceBetween: 50, // 设置 slides 之间的间距
      },
    };
  },
  async created() {
    vm = this // 保存当前实例引用
    await this.initData();
  },
  methods: {
    async initData () {
      const result = await getBannerListing('2');
      this.bannerList = result.data.list;

      const aboutDatalist = await getDataList(localStorage.getItem('pageId'));
      this.aboutList = aboutDatalist.data.list;

      // 在数据更新后执行 DOM 操作
      this.$nextTick(() => {
        const boxes = document.querySelectorAll('.about-team-cont-box');
        if (boxes.length > 0) {
          let maxHeight = 0;
          
          boxes.forEach(box => {
            maxHeight = Math.max(maxHeight, box.offsetHeight);
          });
          
          boxes.forEach(box => {
            box.style.height = `${maxHeight}px`;
          });
        }
      });
    },
    positionClick(index,event) {
      this.positionActive = index;
  
      this.$nextTick(() => {
        const targetId = this.navList[index].id;
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          // 阻止 <a> 标签的默认跳转行为
          if (event) {
            event.preventDefault();
          }
          
          // 计算目标位置
          const offsetTop = targetElement.offsetTop + 100;
          console.log('元素距离文档顶部的位置:', offsetTop);
          // 使用原生平滑滚动
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
          
          // 可选：在滚动完成后添加视觉反馈
          /*
          setTimeout(() => {
            targetElement.style.transition = 'box-shadow 0.5s ease';
            targetElement.style.boxShadow = '0 0 20px rgba(213, 220, 200, 0.8)';
            
            // 2秒后移除高亮效果
            setTimeout(() => {
              targetElement.style.boxShadow = '';
            }, 2000);
          }, 1000);
          */
        }
      });
    },
    openInquiryForm(){
      bus.$emit('inquiry-form', true)
    },
  },
  mounted() {
    // 页面挂载后执行逻辑
  }
};
</script>

<style scoped>
/* 样式部分 */
.about {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}
.about-bg {
  width: 100%;
  height: 100%;
  position: relative;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 2%;
}
.about-bg-img{
  width: 100%;
  height: 580px;
}
.about-bg-img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.about-bg-breadcrumb{
  width: 80%;
  height: 10%;
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 60px;
  display: flex;
  align-items: center;
  padding-left: 3%;
  position: absolute;
  top: calc(580px - 5%);
  left: 10%;
  z-index: 1;
}
.about-bg-breadcrumb .breadcrumb{
  margin: 0;
  font-size:1.5rem;
}
.about-bg-breadcrumb .breadcrumb a{
  color: #959595;
  text-decoration: none;
}
.about-bg-breadcrumb .breadcrumb-item.active{
  font-weight: bold;
  color: #1E1E1E;
}
.about-bg-position{ 
  width: 80%;
  margin: 5% auto 0;
  height: 46px;
  display: flex;
  justify-content: center;
  gap: 8%;
}
.about-bg-position-item{
  padding: 1%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.about-bg-position-item a{
  color: #1E1E1E;
  text-decoration: none;
}
.about-bg-position-item-active{
  background: #D5DCC866;
  font-weight: bold;
}
.about-bg-information{
  position: fixed;
  bottom: 0%;
  right: 7%;
  width: 12vw;
  height: 12vw;
  cursor: pointer;
  z-index: 99;
}
.about-bg-information img{
  width: 100%;
  height: 100%;
}
/* 内容 */
.about-cont{
  width: 100%;
  height: 100%;
  padding: 4% 0 6%;
}
.about-brand{
  width: 80%;
  margin: 0 auto;
  /* height: 500px; */
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 30px;
  display: flex;
  justify-content: center;
  padding: 4% 5% 3%;
}
.about-brand-item{
  width: 33.33%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1vw;
  padding: 0 2%;
}
.about-brand-item-img{
  width: 96px;
  height: 96px;
}
.about-brand-item-img img{
  width: 100%;
  height: 100%;
}
.about-brand-item-title{
  font-weight: bold;
  font-size: 24px;
  color: #1E1E1E;
}
.about-brand-item-line{
  width: 80px;
  height: 5px;
  background: #D5DCC8;
}
.about-brand-item-text{
    font-size: 0.8vw;
    color: #333333;
    line-height: 2vw;
    font-family: "Source Han Sans CN", "思源黑体", sans-serif;
}

/* 关于komo ========================== */
.about-about {
  width: 80%;
  margin: 0 auto;
  height: 54vw;
}
.about-about-div{
  width: 100%;
  height: 100%;
}
.about-about-cont{
  display: flex;
  position: relative;
  width: 100%;
  height: 66%;
}
.about-about-cont-item{
  width: 40%;
  position: absolute;
  left: 3%;
  top: 0;
  text-align: center;
  z-index: 1;
}
.about-about-cont-item-span{
  font-weight: bold;
  font-size: 2vw;
  color: #D5DCC8;
  margin-top: 2%;
  display: block;
}
.about-about-cont-item img{
  width: 100%;
  height: 100%;
}
.about-about-cont-item-pick{
  width: 60%;
  background: #ececec;
  border-radius: 30px;
  height: 23vw;
  position: absolute;
  right: 3%;
  bottom: 23%;
  padding-left: 8%;
}
.about-about-cont-item-pick-item{
  width: 100%;
  height: 100%;
  padding: 6% 4% 3% 0;
}
.about-about-cont-item-pick-item-title{
  width: 100%;
  height: 4vw;
  font-family: "Source Han Sans CN", "思源黑体", sans-serif;
  font-weight: bold;
  color: #1E1E1E;
  padding: 0 2%;
  margin-bottom: 2%;
}
.about-about-cont-item-pick-item-title-p1{
  font-size: 2vw;
  margin: 0;
}
.about-about-cont-item-pick-item-title-p2{
  font-size: 1.8vw;
  margin: 0;
}
.about-about-cont-item-pick-item-cont{
  width: 100%;
  height: 13vw;
  font-family: "Source Han Sans CN", "思源黑体", sans-serif;
  font-size: 1.4vw;
  color: #959595;
}
.about-about-cont-item-pick-item-cont-btn{
    width: 20%;
    height: 42px;
    border-radius: 10px;
    border: 1px solid #979797;
    font-size: 1.4vw;
    color: #1E1E1E;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.about-about-cont-item-pick-item-cont-btn:hover{
  background: #1e1e1e;
}
/* 关于komo end ============================ */

/* service ========================== */
.about-service{
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.about-service-cont{
  width: 100%;
  height: 100%;
  background: #D5DCC880;
  padding: 3% 0;
}
.about-service-padding{
  width: 80%;
  margin: 0 auto;
  height: 100%;
}
.about-service .swiper-slide{
  height: 24vw;
  position: relative;
} 
.about-service .swiper-slide img{
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.about-service .swiper-slide .about-service-cont-item-title{
  position: absolute;
  top: 6%;
  left: 1vw;
  font-size: 1.2vw;
  font-weight: bold;
  color: #1e1e1e;
}
.about-service .swiper-resolveCont{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 80%;
  cursor: pointer;
  transition: transform 0.8s ease;
  transform: translateY(72%);

}
.about-service .swiper-resolveCont:hover{
  transform: translateY(0px);
}
.about-service .swiper-resolveCont-bg{
  background: #1E1E1E;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 0px 0px 30px 30px;
  opacity: 0.6;
  position: absolute;
  bottom: 0;
  width: 100%;
  height:100%;
}
.about-service .swiper-resolveCont-cont{
  position: absolute;
  bottom: 0;
  width: 100%;
  height:100%;
  display: flex;
  align-items: center;
  /* justify-content: space-evenly; */
  flex-direction: column;
  padding: 6%;
}
.about-service .swiper-resolveCont .swiper-resolveCont-title{
  font-weight: bold;
  font-size: 32px;
  color: #FFFFFF;
  opacity: 1;
  padding-bottom: 3%;
}
.about-service .swiper-resolveCont .swiper-resolveCont-text{
  font-size: 22px;
  color: #FFFFFF;
  opacity: 1;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  height: 100%;
  font-weight: 100;
}

.about-service .indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3% 0 0;  
}
  
.about-service .indicators .item {
  width: 1.3vw;
  height: 1.3vw;
  border-radius: 50%;
  margin-left: 10px;
  background: #959595;
}
.about-service .indicators .active {
  background: #1e1e1e;
}

.about-team{
  width: 80%;
  margin: 0 auto;
  height: 100%;
}
.about-team-cont{
  display:flex;
  padding: 10% 0 0;
}
.about-team-cont-item{
  width: 33.33%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 0 2%;
}
.about-team-cont-item-img{
  width: 14vw;
  height: 15vw;
  position: absolute;
  top:-9vw;
}
.about-team-cont-item-img img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.about-team-cont-box{
  width: 100%;
  /* height: 600px; */
  background: #E9E9E9;
  border-radius: 30px;
  padding: 29% 4% 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.about-team-cont-box-name{
  font-family: "Source Han Sans CN", "思源黑体", sans-serif;
  font-weight: bold;
  font-size: 2vw;
  color: #64715D;
  margin-bottom: 2.5%;
}
.about-team-cont-box-title{
  font-family: "Source Han Sans CN", "思源黑体", sans-serif;
  font-weight: bold;
  font-size: 1.2vw;
  color: #1E1E1E;
  text-align: center;
}
.about-team-cont-box-titleBottom{
  text-align: center;
  font-family: "Source Han Sans CN", "思源黑体", sans-serif;
  font-size: 0.8vw;
  margin-bottom: 2.5%;
  color: #1E1E1E;
}
.about-team-cont-box-text{
  text-align: center;
  font-family: "Source Han Sans CN", "思源黑体", sans-serif;
  font-size: 1.2vw;
  color: #1E1E1E;
}
.about-team-cont-box-texttwo{
  text-align: center;
  font-family: "Source Han Sans CN", "思源黑体", sans-serif;
  font-size: 1.2vw;
  color: #1E1E1E;
}


@media (max-width: 1910px) {
  /* .about-about-cont-item-pick-item-title-p1{
    font-size: 2.2rem;
  } */
}
@media (max-width: 1685px) {
  /* .about-about-cont-item-pick-item-title {
    height: 105px;
    margin-bottom: 0;
  } */
  /* .about-about-cont-item-pick-item-title-p1{
    font-size: 2rem;
  } 
  .about-about-cont-item-pick-item-title-p2{
    font-size: 1.8rem;
  }*/
  /* .about-about-cont-item-pick-item-cont{
    height: 200px;
  } */
}
@media (max-width: 1530px) {
  /* .about-about-cont-item-pick-item-title-p1{
    font-size: 1.8rem;
  } 
  .about-about-cont-item-pick-item-title-p2 {
    font-size: 1.6rem;
  }*/
  /* .about-about-cont-item-pick-item-title{
    height: 96px;
  } */
  /* .about-about-cont-item-pick-item-cont{
    height: 220px;
  } */
}
</style>